import { render, staticRenderFns } from "./EventCurrencyDropdown.vue?vue&type=template&id=4ecf8423"
import script from "./EventCurrencyDropdown.vue?vue&type=script&lang=js"
export * from "./EventCurrencyDropdown.vue?vue&type=script&lang=js"
import style0 from "./EventCurrencyDropdown.vue?vue&type=style&index=0&id=4ecf8423&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports